import * as React from "react";
import { useState, useEffect} from "react"
import PageContainer from "../core/PageContainer";
import Modal from "../core/Modal";
import { jfetch, toast } from "../../utils";
import Button from "../core/Button";

interface IProps {
  userContext:any;
}

function Product(props:IProps){
  
  const [productsModal, setProductsModal] = useState(false)
  const [pageModal, setPageModal] = useState(false)
  const [settingsModal, setSettingsModal] = useState(false)
  const [products, setProducts] = useState([])
  const [label, setLabel] = useState('')
  const [desc, setDesc] = useState('')
  const [purchasable, setPurchasable] = useState('true')
  const [message, setMessage] = useState('')
  const [amount, setAmount] = useState('')
  const [promo, setPromo] = useState(null)
  const [promo2, setPromo2] = useState(null)
  const imageInputRef:any = React.useRef()
  const imageInputRef2:any = React.useRef()
  const [x, setX] = useState('8px')
  const [y, setY] = useState('20px')
  const [h, setH] = useState('100px')
  const [element, setElement] = useState('rowStart')
  const [colWidth, setColWidth] = useState('12')
  const [curProduct, setCurProduct] = useState(null)
  const [pickProduct, setPickProduct] = useState(false)
  const [productsData, setProductsData] = useState([])
  const [page, setPage] = useState([])
  const [pageHTML, setPageHTML] = useState(null)
  const [creatingProduct, setCreatingProduct] = useState(false)

  let row_style = {paddingTop:'0px', paddingBottom:y}
  let col_style = {paddingLeft:x, paddingRight:x}
  let image_style = {
    height:h,
    backgroundSize:'cover',
    backgroundPosition:'center'
  }
  //background: "linear-gradient(0deg, rgba(2,0,36,1) 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,0.018644957983193322) 100%)",
  let overlay_style = {
    height:h,
    display:'flex',
    justifyContent:'center'
  }

  let text_style = {
    color:'white',
    display:'flex',
    alignSelf:'flex-end'
  }

  useEffect(() => {
    init()
  }, [])

  async function init(){
    let resp = await jfetch.get('/products')
    setCurProduct(resp.products[0].id)
    setProducts(resp.products)
    let resp2 = await jfetch.get('/global_settings/show')
    const pp = resp2.setting.products_page
    if(pp?.h){
      setH(pp.h)
    }
    if(pp?.x){
      setX(pp.x)
    }
    if(pp?.y){
      setY(pp.y)
    }
    if(resp2.setting.products_data){
      setProductsData(resp2.setting.products_data)
    }
  }

  //format data for html
  useEffect(() => {
    let new_page = []
    let new_row = []
    productsData.forEach((el , i) => {
      switch (el.type) {
        case 'rowStart':
          // clear array
          new_row = []
          break;
        case 'product': 
          new_row.push(el)
          break;
        case 'rowEnd':
          new_page.push(new_row)
          // new_row.length = 0
          break;
      }
      // if last elemnt is not rowEnd finish row anyways
      if( (i + 1 == productsData.length) && el.type != 'rowEnd'){
        new_page.push(new_row)
        new_row.length = 0
      }
    })
    setPage(new_page)
  }, [productsData])

  useEffect(() => {
    let new_html = page.map((row, i) => {
      let dark = row.length == 0 ? {backgroundColor:'grey'} : {}
      let products_html = row.map((product) => {
        let p_data:any = {}
        products.forEach(p => {
          if(p.id == +product.product_id){
            p_data = p
          }
        });
        let image_url = { backgroundImage:`url('${p_data.promo_url}')`}
        let new_img_style = { ...image_style, ...image_url };
        let overlay:any = {}
        if(p_data.show_title){
          overlay.background = "linear-gradient(0deg, rgba(2,0,36,1) 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,0.018644957983193322) 100%)";
        }
        let new_overlay_style = { ...overlay, ...overlay_style}
        const link = p_data.purchasable ? `/upgrade?product_id=${product.product_id}` : `/order_product?product_id=${product.product_id}`
        return (
          <a key={product.product_id} href={link} target="blank" rel="noopener noreferrer">
            <div className={`col-lg-${product.col}`} style={col_style}>
              <div className="product-img" style={new_img_style}>
                <div className="overlay" style={new_overlay_style}>
                  { p_data.show_title && <h3 style={text_style}>{p_data.label}</h3> }
                </div>
              </div>
            </div>
          </a>
        )
      })
      return (
        <div key={i} className="row" style={{...row_style, ...dark}}>
          {products_html}
        </div>
      )
    })
    setPageHTML(new_html)
  }, [page, x, y, h])

  function setFile(event){
    setPromo(event.target.files[0])
  }

  function setFile2(event){
    setPromo2(event.target.files[0])
  }

  function createProduct(){

    setCreatingProduct(true)
    const formData = new FormData();
    
    formData.append("label", label);
    formData.append("desc", desc);
    formData.append("amount", amount);
    formData.append("message", message);
    formData.append("purchasable", purchasable)
    if(!purchasable){
      formData.append("promo2", promo2)
    }
    formData.append("promo", promo);
    
    jfetch.post('/products', formData)
    .then((resp) => {
      setProducts(resp.products)
      setLabel('')
      setDesc('')
      setAmount('')
      setMessage('')
      setPurchasable('')
      setPromo(null)
      setPromo2(null)
      imageInputRef.current.value = "";
      if(imageInputRef2?.current){
        imageInputRef2.current.value = ""
      }
      setCreatingProduct(false)
    })
  }

  function destroyProduct(id){
    jfetch.delete(`/products/${id}`)
    .then((resp) => {
      setProducts(resp.products)
    })
  }

  function elementChange(e){
    setElement(e.target.value)
    if(e.target.value == 'product'){
      setPickProduct(true)
    }
    else{
      setPickProduct(false)
    }
  }

  async function saveStyles(){
    const data = {
      global_setting:{
        products_page:{
          h:h,
          x:x,
          y:y
        }
      }
    }
    await jfetch.patch('/global_settings/update', data)
    setSettingsModal(false)
    toast.success('Page Settings Saved!')
  }

  function addElement(){
    let new_el = {type:element}
    if(element == 'product'){
      new_el['product_id'] = curProduct
      new_el['col'] = colWidth
      switch (colWidth) {
        case '12':
          new_el['colDesc'] = 'Full Width'
          break;
        case '6':
          new_el['colDesc'] = 'Half Width'
          break;
        case '4':
          new_el['colDesc'] = '1/3 Width'
          break;          
        case '3':
          new_el['colDesc'] = '1/4 Width'
          break;
        case '2':
          new_el['colDesc'] = '1/6 Width'
          break;                       
        default:
          break;
      }
    }
    let data_clone = [...productsData]
    data_clone.push(new_el)
    setProductsData(data_clone)
  }

  function removeElement(){
    let data_clone = [...productsData]
    data_clone.pop()
    setProductsData(data_clone)
  }

  async function savePage(){
    const data = {
      global_setting:{
        products_data:productsData
      }
    }
    await jfetch.patch('/global_settings/update', data)
    setPageModal(false)
    toast.success('Page Settings Saved!')    
  }

  let showButtons = props.userContext.user.data.attributes.isAdmin ? 'initial' : 'none'

  return (
    <PageContainer>   
      <div className="row" style={{padding:'15px 0px', display:showButtons}}>
        <div className="col-lg-12">
          <a className="btn btn-primary" style={{borderRadius:'18px', cursor:'pointer'}} onClick={() => setProductsModal(true)} >
            <i className="fa fa-shopping-cart" style={{fontSize:'22px'}} />
          </a>
          <Modal
            title="Edit Products"
            open={productsModal}
            close={() => setProductsModal(false)}
            submittable={false}
            isLarge={true}
            disallowClickOutside={true}
            submitText="Save"
          >
            <div className="container-fluid" style={{margin:'0px'}}>
              <div className="row">
                <div className="col-lg-3">
                  <input value={label} onChange={(e) => setLabel(e.target.value)} type="text"  className="form-control" placeholder="NAME"/>
                </div>
                <div className="col-lg-3">
                  <input value={desc} onChange={(e) => setDesc(e.target.value)} type="text" className="form-control" placeholder="DESCRIPTION"/>
                </div>
                <div className="col-lg-3">
                  { purchasable == 'true' && (
                    <input value={amount} onChange={(e) => setAmount(e.target.value)} type="text" className="form-control" placeholder="AMOUNT"/>
                  )}
                </div>
                <div className="col-lg-3">
                  <div>
                    <label>Can Be Purchased?</label>
                  </div>
                  <select name="purchasable" value={purchasable} onChange={(e) => setPurchasable(e.target.value)}>
                    <option value="true">YES</option>
                    <option value="false">NO</option>
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <label>Product Image</label>
                  <input type="file" name="promo" id="promo" accept=".jpg,.jpeg,.gif,.png" onChange={setFile.bind(this)} ref={imageInputRef} />
                </div>
                { purchasable == 'false' && (
                  <div className="col-lg-6">
                    <label>Second Page Image</label>
                    <input type="file" name="promo2" id="promo2" accept=".jpg,.jpeg,.gif,.png" onChange={setFile2.bind(this)} ref={imageInputRef2} />
                  </div>   
                )}          
              </div>
              { purchasable == 'false' && (
                <div className="row">
                  <div className="col-lg-6">
                    <textarea name="message"  placeholder="Product Message" onChange={(e) => setMessage(e.target.value)} rows={3}/>
                  </div>  
                </div>
              )}
              <div className="row">
                <div className="col-lg-3">
                  <Button color="primary" onClick={createProduct} loading={creatingProduct}>Create Product</Button>
                </div>              
              </div>
              <div className="row" style={{paddingTop:'30px'}}> 
                <div className="col-lg-12">
                  <table className="table table-striped">
                    <tr>
                      <th style={{color:'black'}}>Name</th>
                      <th style={{color:'black'}}>Description</th>
                      <th style={{color:'black'}}>Image</th>
                      <th style={{color:'black'}}>Price</th>
                      <th style={{color:'black'}}>Delete</th>
                    </tr>
                    {products.map((product) => {
                      return (
                        <tr key={product.id}>
                          <td style={{color:'black', padding:'7px 0px'}}>{product.label}</td>
                          <td style={{color:'black', padding:'7px 0px'}}>{product.desc}</td>
                          <td style={{color:'black', padding:'7px 0px'}}>
                            { product.promo_url ? <a href={product.promo_url} target='_blank' rel="noopener noreferrer">Image</a> : <span>No Image</span> }
                          </td>                        
                          <td style={{color:'black', padding:'7px 0px'}}>{product.amount}</td>
                          <td style={{color:'black', padding:'7px 0px'}}>
                            { product.id != 1 && product.id != 2 && (
                              <a onClick={() => destroyProduct(product.id)} style={{cursor:'pointer'}}>
                                Delete <i className="fa fa-trash" />
                              </a>
                            )}
                          </td>
                        </tr>
                      )
                    })}
                  </table>
                </div>
              </div>
            </div>
          </Modal>
          <a className="btn btn-primary" style={{borderRadius:'18px', cursor:'pointer', marginLeft:'10px'}} onClick={() => setPageModal(true)} >
            <i className="fa fa-pencil" style={{fontSize:'22px'}} />
          </a>
          <Modal
            title="Build Page"
            open={pageModal}
            close={() => setPageModal(false)}
            submittable={true}
            isLarge={true}
            disallowClickOutside={true}
            submitText="Save Page"
            onSubmit={savePage}
          >
            <div className="container-fluid" style={{margin:'0px'}}>
              <div className="row">
                <div className="col-lg-3">
                  <div>
                    <label>Select New Item</label>
                    <select value={element} onChange={(e) => elementChange(e)}>
                      <option value='rowStart'>Row Start</option>
                      <option value='product'>Product</option>
                      <option value='rowEnd'>Row End</option>
                    </select>
                  </div>
                  <div style={{paddingTop:'15px'}}>
                    <Button color="primary" onClick={addElement}>Add Element</Button>
                  </div>
                  <div style={{paddingTop:'15px'}}>
                      <Button color="danger" onClick={removeElement}>Delete Last Element</Button>
                    </div>                  
                </div>
                <div>
                  <div className="col-lg-3" style={{display: pickProduct ? 'initial' : 'none'}}>
                    <div>
                      <label>Choose Product</label>
                    </div>
                    <div>
                      <select value={curProduct} onChange={(e) => setCurProduct(e.target.value)}>
                        {products.map((product) => {
                          return <option key={product.id} value={product.id}>{product.label}</option>
                        })}
                      </select>
                    </div>                     
                  </div>
                  <div className="col-lg-3" style={{display: pickProduct ? 'initial' : 'none'}}>
                    <div>
                      <label>Choose Width</label>
                    </div> 
                    <div>
                      <select value={colWidth} onChange={(e) => setColWidth(e.target.value)}>
                        <option value='12'>Full Column</option>
                        <option value='6'>Half Column</option>
                        <option value='4'>1/3 Column</option>
                        <option value='3'>1/4 Column</option>
                        <option value='2'>1/6 Column</option>
                      </select>
                    </div> 
                  </div>
                </div>
              </div>
              <div style={{marginTop:'30px', border:'1px solid #687b8e', padding: '0px 15px'}}>
                {productsData.map((el) => {
                  let p;
                  if(el.type == 'product'){
                    products.forEach((product) => {
                      if(product.id == el.product_id){
                        p = product
                      }
                    })
                  }
                  return (
                    <div key={el.product_id} className="row" style={{backgroundColor: '#3d4853', color:'white', paddingTop:'10px', paddingBottom:'10px', borderBottom:'1px solid white'}}>
                      <div className="col-lg-12">
                        [{el.type}] --  
                        { el.type == 'product' && (
                          <>
                            {` ${p.label}`} -- {el.colDesc}
                          </>
                        )}
                      </div>
                    </div>   
                  )             
                })}
              </div>
            </div>
          </Modal>
          <a className="btn btn-primary" style={{borderRadius:'18px', cursor:'pointer', marginLeft:'10px'}} onClick={() => setSettingsModal(true)} >
            <i className="fa fa-cog" style={{fontSize:'22px'}} />
          </a>
          <Modal
            title="Page Settings"
            open={settingsModal}
            close={() => setSettingsModal(false)}
            submittable={true}
            isLarge={true}
            disallowClickOutside={true}
            submitText="Save"
            onSubmit={saveStyles}
          >
            <div className="container-fluid" style={{margin:'0px'}}>
              <div className="row">
                <div className="col-lg-3">Image Height</div> 
                <div className="col-lg-6">
                    <input type="text" className="form-control" value={h} onChange={(e) => setH(e.target.value) } />
                </div> 
              </div>
              <div className="row">
                <div className="col-lg-3">Space Between rows</div> 
                <div className="col-lg-6">
                    <input type="text" className="form-control" value={y} onChange={(e) => setY(e.target.value)} />
                </div>
              </div> 
              <div className="row">
                <div className="col-lg-3">Horizontal Spacing[each column]</div> 
                <div className="col-lg-6">
                  <input type="text" className="form-control" value={x} onChange={(e) => setX(e.target.value)} />
                </div>
              </div>                       
            </div>
          </Modal>                
        </div>
      </div>
      {pageHTML}
    </PageContainer>
  )
}

export default Product


// WEBPACK FOOTER //
// ./app/javascript/components/pages/Products.tsx